import React, { type InputHTMLAttributes } from "react";
import { Field } from "redux-form";
import type IFormInputs from "./IFormInputs";
import { InputRenderer } from "src/shared/forms/formrenderers/InputRenderer";

export interface CheckboxInputProps
  extends IFormInputs,
    InputHTMLAttributes<HTMLInputElement> {
  type?: "checkbox" | "radio";
}

export const CheckboxInput = (props: CheckboxInputProps) => {
  const { inputID, label = null, type = "checkbox", ...rest } = props;

  return (
    <Field
      name={inputID}
      label={label}
      component={InputRenderer}
      type={type}
      {...rest}
    />
  );
};

/**
 * @deprecated
 */
export default CheckboxInput;
